import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Home, Users, Calendar, Loader2, CircleDollarSign } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from './ui/card';
import { getProperties } from '../lib/inspectionService';
import { useAuth } from "../AuthContext";


const PropertyList = () => {
  // Sample data - replace with your backend data
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const { userId } = useAuth();

  useEffect(() => {
    fetchProperties();
  }, []);

  const fetchProperties = async () => {
    try {
      // Simulate API call with setTimeout
      const data = await getProperties(userId);

      // Example data - replace this with your actual API call
      setProperties(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching properties:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-6 py-8">
      <div className="flex justify-between items-center mb-8">
        <h4 className="text-xl font-bold">My Properties</h4>
        <Link
          to="/properties/new"
          className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-700"
        >
          <Plus className="w-4 h-4" />
          Create Listing
        </Link>
      </div>

      <div className="grid gap-6">
        {properties.map((property) => (
          <Link key={property.id} to={`/properties/${property.id}/prospects`}>
            <Card className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <CardTitle className="flex justify-between items-start">
                  <span>{property.address}, {property.suburb}</span>
                  <span className="text-sm text-gray-500">{property.type}</span>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex items-center gap-2">
                    <Home className="w-4 h-4 text-gray-500" />
                    <span>{property.bedroom}bed, {property.bathroom}bath</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <CircleDollarSign className="w-4 h-4 text-gray-500" />
                    <span>Price: {property.price}</span>
                  </div>
                </div>
              </CardContent>
              <CardFooter className='bg-gray-200 flex justify-center items-center'>
                  <div className="flex items-center gap-2 h-full">
                    <Users className="w-4 h-4 text-gray-500" />
                    <span><b>{property.prospect}</b> active prospects</span>
                  </div>
              </CardFooter>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PropertyList;